import { DATE_FORMAT_WEEK_DAY, normalizeToDate } from 'utils/date-time';
import { getHttpStatus } from 'utils/httpError';

import messages from './messages';
import { SESSION_TYPE } from './constants';

export const buildOptions = ({ isQuarantinedCity, availableTypes }) => {
  const jobTypeFixed = {
    value: SESSION_TYPE.FIXED,
    label: messages.fixedSessionLabel,
    name: SESSION_TYPE.FIXED,
    disabled: isQuarantinedCity,
  };

  const ownerPhotosType = {
    value: SESSION_TYPE.OWNER_PHOTOS,
    label: messages.ownerPhotosSessionLabel,
    name: SESSION_TYPE.OWNER_PHOTOS,
  };

  const jobTypeFlexible = {
    value: SESSION_TYPE.FLEXIBLE,
    label: messages.flexibleSessionLabel,
    name: SESSION_TYPE.FLEXIBLE,
    disabled: isQuarantinedCity,
  };

  return [
    ...(isQuarantinedCity ? [ownerPhotosType] : []),
    ...(availableTypes.includes(SESSION_TYPE.FLEXIBLE) ? [jobTypeFlexible] : []),
    ...(availableTypes.includes(SESSION_TYPE.FIXED) ? [jobTypeFixed] : []),
  ];
};


export const buildButtons = ({ handleOnClickContinue, disableContinueBtn, handleOnClickBack, continueButtonLabel }) => [
  {
    label: continueButtonLabel,
    onClick: handleOnClickContinue,
    disabled: disableContinueBtn,
    fullWidth: true,
    hasSpacing: true,
  },
  {
    label: messages.backButtonLabel,
    onClick: handleOnClickBack,
    fullWidth: true,
    hasSpacing: true,
  },
];

const getPhotoSender = ({ sessionType }) => sessionType === SESSION_TYPE.FLEXIBLE ? 'PHOTOGRAPHER' : 'OWNER';

export const buildFlexiblePayload = ({ photoSessionDetail: { lockbox }, sessionType }) => ({
  lockBox: lockbox,
  fromDaysAhead: 1,
  photoSender: getPhotoSender({ sessionType }),
  givePreferenceToLastAgent: true,
});

const filterAvailableSlots = ({ available }) => available;

const mapSlots = ({ id, time }) => ({
  label: time,
  ariaLabel: time,
  name: id,
});

const getAvailableTimes = (schedule) =>
  (schedule && Array.isArray(schedule.slots) ? schedule.slots : [])
    .filter(filterAvailableSlots)
    .map(mapSlots);

export const mapSchedulesDatesAndTime = (schedules, intl) => {
  if (!schedules || typeof schedules !== 'object') {
    return [];
  }

  const mappedDatesAndTime = Object.keys(schedules).map((date) => ({
    label: intl.formatDate(normalizeToDate(date), DATE_FORMAT_WEEK_DAY),
    ariaLabel: date,
    value: date,
    times: getAvailableTimes(schedules[date]),
  }));
  const filteredDates = mappedDatesAndTime.filter(({ times }) => times.length > 0);
  return filteredDates.map((date, index) => ({
    ...date,
    name: index,
  }));
};

// requireLastAgent: the backend answers 409 instead of reassigning the session to another photographer.
export const buildFixedPayload = ({
  photoSessionDetail: { lockbox }, date, beginSlot, requireLastAgent,
}) => ({
  lockBox: lockbox,
  date,
  beginSlot,
  givePreferenceToLastAgent: true,
  requireLastAgent,
});

export const isLastPhotographerUnavailableError = (error) => getHttpStatus(error) === 409;
